// extracted by mini-css-extract-plugin
export var advance = "advance-module--advance--0fc2f";
export var advance__block = "advance-module--advance__block--92734";
export var blockTitle = "advance-module--block-title--fcc8e";
export var col = "advance-module--col--e53f8";